export default {"src":"/_next/static/media/hm-logo-black.3294dbfd.svg","height":118,"width":216,"blurWidth":0,"blurHeight":0};